module.exports = __webpack_public_path__ + "img/looks_two.19a768a4.svg";